define('models/calendar/nutrition/entry',[
    'underscore', 'backbone', 'utils',
    // services
    'services/nutrition/entry-tag',
    // models & collections
    'models/calendar/nutrition/food',
    'collections/calendar/nutrition/servings',
], function(
    // libs
    _, Backbone, U,
    // services
    EntryTagService,
    // models & collections
    MFood,
    CServings
) {

    var MEntry = Backbone.Epoxy.Model.extend({
        blacklist: ['_food', 'text'],
        defaults: {
            isEaten: false,
            enteredBy: "member",
            foodServing: null,
            tag: null,
            _food: null,
            hour: 0,
        },

        computeds: {
            serving: {
                deps: ['foodServing'],
                get: getServingId,
                set: setServingId
            },
        },

        initialize: function(attrs, options) {
            var food = this.food = new MFood(this.get('_food'));
            this.servings = this.food.getServings();
            this._updateServing();

            if (!this.has('qty')) this.applyQuantity();

            this.listenTo(this, {
                'change:foodServing': this.onServingChange,
                'sync model:reset change:_food': this.onUpdate
            });

            this.listenTo(food, { 'sync': this.onFoodSync });

        },
        // set a default serving if necessary
        _updateServing: function() {
            // if there's no food OR the item is not an image, reset servings and related attributes
            // The better way to exclude an item that does not have a food associated with it would be to make sure _food for images is set to true
            // then we can remove path and full and only use _food
            if (!this.get('_food') && !this.get('path') && !this.get('full')) {
                this.set({
                    foodServing: null,
                    isEaten: false,
                });
                this.servings.reset();
            }

            var servingId = this.getServingId(),
                food = this.food,
                serving = servingId && food.getServing(servingId);
            if (!serving) {
                serving = food.getDefaultServing();
            } // not a else if on purpose
            if (serving) this.setServingId(serving.id);
        },

        setServingId: function(value, options) {
            return this.set(setServingId.call(this, value), options);
        },

        getServingId: getServingId,

        getFoodId: function() { return this.food.id; },
        getFood: function() { return this.food; },
        hasFood: function() { return !this.food.isNew(); },

        setFood: function(attrs, options) {
            return this.set({ _food: attrs }, options);
        },

        removeFood: function(options) {
            this.set({ _food: null, }, options);
        },

        isEaten: function(value, options) {
            if (!_.isUndefined(value)) {
                this.set('isEaten', value, options);
                return value;
            }
            return this.get('isEaten');
        },

        isSuggestion: function() {
            return Boolean(this.get('tag'));
        },

        getSuggestionText: function() {
            return EntryTagService.getText(this.get('tag'));
        },

        applyQuantity: function() {
            var serving = this.servings.get(this.getServingId());
            this.set('qty', serving ? serving.get('qty') : 0);
        },

        enteredBy: function(value) {
            if (value) this.set('enteredBy', value);
            return value || this.get('enteredBy');
        },

        updateServings: function() {
            // this.servings.reset(this.food.getServings());
            this._updateServing();
            this.applyQuantity();
        },

        addNutrientTo: function(nutrientObj) {
            if (this.hasFood()) {
                var serving = this.servings.get(this.getServingId()),
                    qty = this.get('qty');
                if (serving) {
                    var nutrients = serving.getNutrients();
                    _.each(nutrients, function(value, key) {
                        if (!nutrientObj[key]) nutrientObj[key] = 0;
                        nutrientObj[key] += value * qty;
                    });
                }
            }
            return nutrientObj;
        },

        getCalories: function() {
            if (this.hasFood()) {
                var serving = this.servings.get(this.getServingId()),
                    nutrients = serving && serving.getNutrients(),
                    qty = this.get('qty');
                return nutrients ? nutrients.calories * qty || 0 : 0;
            }
            return 0;
        },

        ////////////
        // events //
        ////////////
        onUpdate: function() {
            this.food.reset(this.get('_food'));
            this.updateServings();
        },

        onServingChange: function(model, value, options) {
            this.applyQuantity();
        },

        onFoodSync: function() {
            _.extend(this.get('_food'), this.food.toJSON());
            this.updateServings();
        },

        ////////////////
        // validation //
        ////////////////
        validation: {
            hour: {
                presence: true,
                numericality: {
                    onlyInteger: true,
                    greaterThanOrEqualTo: 7,
                    lessThanOrEqualTo: 21,
                    message: "The serving must be in the day.",
                },
            },
            qty: {
                presence: true,
                numericality: {
                    greaterThanOrEqualTo: 0,
                    message: "The quantity must be a positive number.",
                }
            }
        },
    });

    function getServingId() {
        var foodServing = this.get('foodServing');
        if (_.isString(foodServing)) return foodServing.split(':')[1];
    }

    function setServingId(value) {
        var foodId = this.getFoodId();
        if (foodId) {
            return { foodServing: foodId + ':' + value };
        }
    }

    return MEntry;
});

